import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'lib-marketing-checkbox',
  templateUrl: './marketing-checkbox.component.html',
  styleUrls: ['./marketing-checkbox.component.scss'],
})
export class MarketingCheckboxComponent {
  @Input() value: boolean;
  @Output() valueChange = new EventEmitter<boolean>();

  handleCheck(event) {
    this.valueChange.emit(event.checked);
  }
}
